import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="mx-auto px-6 py-14" style={{ maxWidth: 1280 }}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-base">
                91
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              资源整合 · 服务导航 · 一站直达<br />
              您的首选综合资源服务平台
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              <Link to="/category/resource-navigation" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">资源分类</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">关于我们</Link>
              <a href="#" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">会员中心</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/resource-navigation" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">资源导航</Link>
              <Link to="/category/tools-software" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">工具软件</Link>
              <Link to="/category/learning-tutorials" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">学习教程</Link>
              <Link to="/category/industry-news" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">行业资讯</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <p><i className="ri-phone-line mr-2" />{siteInfo.phone}</p>
              <p><i className="ri-mail-line mr-2" />{siteInfo.email}</p>
              <p><i className="ri-map-pin-line mr-2" />{siteInfo.address}</p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {siteInfo.foundingYear}-{new Date().getFullYear()} {siteInfo.name} 版权所有 | {siteInfo.icp}
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">网站地图</a>
          </div>
        </div>
      </div>
    </footer>
  );
}